import type { IconSvgObject } from './types';

const CircleArrowReload02Icon: IconSvgObject = [
  ["path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12.4999 16H13.4999C14.0522 16 14.4999 15.5523 14.4999 15V8L16.4999 9.5M11.5004 8.00001L10.5004 8.00001C9.94814 8.00001 9.50043 8.44772 9.50043 9.00001V16L7.50043 14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CircleArrowReload02Icon;
